import { SelectField } from "@edgetier/select";
import useRoles from "hooks-for/permissions/use-roles";
import { FunctionComponent } from "react";
import { IProps } from "./select-role.types";
import "./select-role.scss";

/**
 * A drop down for selecting a user role.
 * @param props.name The name of the role field.
 */
const SelectRole: FunctionComponent<IProps> = ({ name, ...otherProps }) => {
    const { data, isLoading } = useRoles();
    return (
        <SelectField
            isLoading={isLoading}
            items={data ?? []}
            name={name}
            getLabel={({ role }) => role}
            getValue={({ roleId }) => roleId}
            description="role"
            {...otherProps}
        />
    );
};

export default SelectRole;
